import { useState, useEffect } from "react";
import servicesData from "../data/services.json";
import ServiceListCard from "../components/cards/ServiceListCard";
import PageHeader from "../components/common/PageHeader";

export default function Courses() {
  const [search, setSearch] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filteredCourses = servicesData.courses.filter((course) =>
    course.title.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="max-w-7xl mx-auto px-6 py-16">
      <PageHeader title="Courses" search={search} setSearch={setSearch} />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {filteredCourses.length > 0 ? (
          filteredCourses.map((course) => (
            <ServiceListCard key={course.slug} item={course} type="courses" />
          ))
        ) : (
          <div className="col-span-full text-center py-20">
            <p className="text-gray-500 text-lg">No courses found 😕</p>
          </div>
        )}
      </div>
    </div>
  );
}
